var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-alert",
        {
          staticClass: "intro",
          attrs: { type: "info", closable: false, "show-icon": "" },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("placesCompare.introTitle"))),
          ]),
          _c("div", { staticClass: "intro-body" }, [
            _vm._v(_vm._s(_vm.$t("placesCompare.introBody"))),
          ]),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "query-card" },
        [
          _c(
            "el-form",
            {
              attrs: { inline: true, size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.run.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("placesCompare.preset") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "190px" },
                      on: { change: _vm.applyPreset },
                      model: {
                        value: _vm.preset,
                        callback: function ($$v) {
                          _vm.preset = $$v
                        },
                        expression: "preset",
                      },
                    },
                    _vm._l(_vm.presets, function (p) {
                      return _c("el-option", {
                        key: p.name,
                        attrs: { label: p.name, value: p.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("placesCompare.latitude") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "130px" },
                    model: {
                      value: _vm.form.latitude,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "latitude", $$v)
                      },
                      expression: "form.latitude",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("placesCompare.longitude") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "130px" },
                    model: {
                      value: _vm.form.longitude,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "longitude", $$v)
                      },
                      expression: "form.longitude",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("placesCompare.category") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { disabled: !!_vm.form.query },
                      model: {
                        value: _vm.form.categoryId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "categoryId", $$v)
                        },
                        expression: "form.categoryId",
                      },
                    },
                    _vm._l(_vm.categories, function (c) {
                      return _c("el-option", {
                        key: c,
                        attrs: {
                          label: _vm.$t("placesCompare.cat_" + c),
                          value: c,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("placesCompare.query") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "160px" },
                    attrs: {
                      clearable: "",
                      placeholder: _vm.$t("placesCompare.queryPlaceholder"),
                    },
                    model: {
                      value: _vm.form.query,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "query", $$v)
                      },
                      expression: "form.query",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("placesCompare.radius") } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "120px" },
                    attrs: {
                      min: 50,
                      max: 5000,
                      step: 100,
                      "controls-position": "right",
                    },
                    model: {
                      value: _vm.form.radius,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "radius", $$v)
                      },
                      expression: "form.radius",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.form.fresh,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "fresh", $$v)
                        },
                        expression: "form.fresh",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("placesCompare.fresh")))]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.run },
                    },
                    [_vm._v(_vm._s(_vm.$t("placesCompare.run")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "hint" }, [
            _vm._v(
              _vm._s(
                _vm.form.query
                  ? _vm.$t("placesCompare.hintSearch")
                  : _vm.$t("placesCompare.hintCategory")
              )
            ),
          ]),
        ],
        1
      ),
      _vm.result
        ? _c(
            "div",
            { staticClass: "verdict" },
            [
              _c("el-card", { attrs: { shadow: "never" } }, [
                _c("div", { staticClass: "verdict-row" }, [
                  _c("div", { staticClass: "verdict-block" }, [
                    _c("div", { staticClass: "verdict-value" }, [
                      _vm._v(_vm._s(_vm.result.google.count)),
                    ]),
                    _c("div", { staticClass: "verdict-label" }, [
                      _vm._v("Google Places"),
                    ]),
                  ]),
                  _c("div", { staticClass: "verdict-block" }, [
                    _c("div", { staticClass: "verdict-value" }, [
                      _vm._v(_vm._s(_vm.result.geoapify.count)),
                    ]),
                    _c("div", { staticClass: "verdict-label" }, [
                      _vm._v("Geoapify"),
                    ]),
                  ]),
                  _c("div", { staticClass: "verdict-block" }, [
                    _c(
                      "div",
                      {
                        staticClass: "verdict-value",
                        class: _vm.result.shared === 0 ? "bad" : "",
                      },
                      [_vm._v(_vm._s(_vm.result.shared))]
                    ),
                    _c("div", { staticClass: "verdict-label" }, [
                      _vm._v(_vm._s(_vm.$t("placesCompare.shared"))),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "verdict-note" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.result.shared === 0
                          ? _vm.$t("placesCompare.verdictNone")
                          : _vm.$t("placesCompare.verdictSome")
                      ) +
                      " "
                  ),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-row",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "split",
          attrs: { gutter: 16 },
        },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("provider-column", {
                attrs: {
                  title: "Google Places",
                  tone: "google",
                  side: _vm.result ? _vm.result.google : null,
                  "other-names": _vm.geoNameSet,
                },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("provider-column", {
                attrs: {
                  title: "Geoapify",
                  tone: "geoapify",
                  side: _vm.result ? _vm.result.geoapify : null,
                  "other-names": _vm.googleNameSet,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }